import { useQuery } from 'react-apollo';

import GraphqlError from '~/components/GraphqlError';
import PageviewsList from '~/components/Sidebar/PageviewsList';
import { paginateData } from '~/lib/graphql/pagination';

import query from './query.graphql';

const initialPageSize = 40;
const perPage = 20;
// NOTE https://github.com/apollographql/apollo-client/blob/master/packages/apollo-client/src/core/networkStatus.ts#L22
const networkIsFetchingMore = 3;

const ListPageviews = ({ person }) => {
  const [path, setPath] = useState('');

  const variables = {
    first: initialPageSize,
    id: person.id,
    ...(path && { path }),
  };

  const {
    data = {
      person: {},
    },
    error,
    fetchMore,
    loading,
    networkStatus,
    refetch,
  } = useQuery(query, { variables, notifyOnNetworkStatusChange: true });

  if (error) {
    return <GraphqlError error={error} loading={loading} refetch={refetch} />;
  }

  const { events, eventsHasNextPage, eventsEndCursor } = paginateData(
    data.person,
    { fields: ['events'] },
  );

  const { eventTypes = [] } = data;

  const firstPageLoading = loading && networkStatus !== networkIsFetchingMore;

  return (
    <PageviewsList
      events={events}
      eventTypes={eventTypes}
      hasNextPage={eventsHasNextPage}
      id={person.id}
      loading={firstPageLoading}
      loadingMore={loading}
      onFilter={(path) => setPath(path)}
      onLoadMore={() => {
        if (loading) {
          return;
        }

        fetchMore({
          variables: {
            ...variables,
            after: eventsEndCursor,
            first: perPage,
          },

          updateQuery: (prev, { fetchMoreResult }) => {
            if (!fetchMoreResult) {
              return prev;
            }

            fetchMoreResult.person.events.edges = [
              ...prev.person.events.edges,
              ...fetchMoreResult.person.events.edges,
            ];

            return fetchMoreResult;
          },
        });
      }}
    />
  );
};

ListPageviews.propTypes = {
  className: PropTypes.string,
  person: PropTypes.object.isRequired,
};

export default ListPageviews;
